/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { QuestionnaireResponseSubmissionRequestAnswers } from "./QuestionnaireResponseSubmissionRequestAnswers";

export interface QuestionnaireResponseSubmissionRequest {
  /** Checksum of the questionnaire definition shown to the user */
  checksum: string;
  /** Question ids mapped to their selected option codes */
  answers: QuestionnaireResponseSubmissionRequestAnswers;
}
